import { HTMLAttributes, Ref } from "react"

import { classNames } from "../../../lib/classNames"

export interface PopoverListItemProps extends HTMLAttributes<HTMLLIElement> {
  isHighlighted: boolean
  ref?: Ref<HTMLLIElement | null>
  disabled?: boolean
}

const PopoverListItem = (props: PopoverListItemProps) => {
  const {
    ref,
    className,
    isHighlighted,
    disabled = false,
    ...otherProps
  } = props

  return (
    <li
      className={classNames(
        "text-v2-foreground-default rounded-control flex items-center text-sm",
        isHighlighted &&
          !disabled &&
          "bg-elevation-surface-container-lowest-default",
        !disabled && "active:bg-neutral-pressed",
        "min-h-8 gap-x-2 px-2",
        "cursor-pointer",
        disabled && "color-button-disabled cursor-default",
        className
      )}
      {...otherProps}
      ref={ref}
    />
  )
}

PopoverListItem.displayName = "PopoverListItem"

export default PopoverListItem
